import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import GetAppIcon from "@mui/icons-material/GetApp";
import React, { FunctionComponent } from "react";
import { CSS_ANCHOR_RESET } from "designSystem/styles/style-functions";
import { AFTER, FOCUS_VISIBLE } from "designSystem/theme";
import IconButton, { IconButtonProps } from "./IconButton";

const PREFIX = "DownloadButton";

const classes = {
	link: `${PREFIX}link`,
};

const StyledLink = styled(Link)(({
	theme,
}) => ({
	[`&.${classes.link}`]: {
		[FOCUS_VISIBLE]: {
			[AFTER]: {
				left: 0,
				top: 0,
				height: "100%",
				width: "100%",
			},
		},
	},
}));

/**
 * This wraps an IconButton with a Link, which keeps us form having to re-implement all
 * styling of a button with a link. However, it causes a few different problems with focus:
 * 1. default link focus adds 2px padding, but not needed around icon button
 * 2. button by default will also get focus, which we don't need because link has focus too
 */

export interface DownloadButtonProps extends IconButtonProps {
	/** href to content to download */
	href: string;
}

const DownloadButton: FunctionComponent<DownloadButtonProps> = (props) => {
	const {
		href,
		res,
		...otherProps
	} = props;

	return (
		<StyledLink
			className={`${CSS_ANCHOR_RESET} ${classes.link}`}
			href={href}
			target="_blank"
		>
			<IconButton
				res={res || "Download"}
				tabIndex={-1}
				{...otherProps}
				size="large"
			>
				<GetAppIcon />
			</IconButton>
		</StyledLink>
	);
};

export default DownloadButton;